{{#if config.label}}
  {{> elements/_page_builder_label label=config.label description=config.description}}
{{/if}}
<div class="image-editor">
  <div class="tool-field">
    <img src="{{#if context.url}}{{context.url}}{{else}}/assets/admin/placeholders/image-empty-1df0fe63.svg{{/if}}" alt="{{#if context.alt}}{{context.alt}}{{else}}Enter alt description{{/if}}" title="{{#if context.title}}{{context.title}}{{else}}Enter title{{/if}}" class="preview">
    {{#if context.cropped }}
      <svg class="icon icon-crop"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="{{ iconSpriteUrl }}#icon-crop-alt"></use></svg>
    {{/if}}
  </div>
</div>
<div class="customized shared-component-options">
  <a href="" class="reset">{{{ icon "close-alt-color" }}} Remove Override</a>
</div>
